<script lang="ts">
import { defineComponent } from 'vue'

import ViewTeambuilding from '~/vue/_teammasters/organisms/views/ViewTeambuilding.vue'

export default defineComponent({
    components: {
        'view--teambuilding': ViewTeambuilding,
    }
})
</script>